'use client';

import { NestedStatusEnum } from '@/config/steps.config';
import { VpAsset } from '@vtmn-play/react';
import { useSearchParams } from 'next/navigation';
import { ReactNode } from 'react';
import { useTranslations } from 'next-intl';

import './WidgetShellWrapper.scss';

interface WidgetShellWrapperProps {
  children?: ReactNode;
}

const WidgetShellWrapper = ({ children }: WidgetShellWrapperProps) => {
  const t = useTranslations('Widget');
  const searchParams = useSearchParams();
  const isNested = searchParams.get(NestedStatusEnum.NESTED) !== null;

  return isNested ? (
    children
  ) : (
    <>
      <header className='standalone-header'>
        <VpAsset
          height={24}
          name='logo-decathlon-lockup-primary-brand'
          aria-hidden={false}
          role='img'
          aria-label={t('component.shellHeader.logoAlt')}
        />
      </header>
      {children}
    </>
  );
};

export default WidgetShellWrapper;
